module.exports = __webpack_public_path__ + "img/search.471f448b.png";